<div class="select-city">
  <div class="regions">
    <div class="region active">Коммерческие помещения</div>
  </div>
  <div class="cities">
    <div class="cities_list">
      <div *ngFor="let type of commercialPremisesTypes; let i = index">
        <div class="city" *ngIf="i < 3">
          <label class="container-checkbox check-floor">{{type.title}}
            <input type="checkbox" [(ngModel)]="type.checked" (ngModelChange)="type.checked = $event"
              (change)="changedModel()">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
      <div class="embedded" *ngIf="commercialPremisesTypes[0].checked">
        <div class="title">
          Встроенные
        </div>
        <div *ngFor="let type of commercialPremisesTypes; let i = index">
          <div class="city" *ngIf="i > 2 && i < 5">
            <label class="container-checkbox check-floor">{{type.title}}
              <input type="checkbox" [(ngModel)]="type.checked" (ngModelChange)="type.checked = $event"
                (change)="changedModel()">
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="embedded" *ngIf="commercialPremisesTypes[1].checked">
        <div class="title">
          Встроенные-пристроенные
        </div>
        <div *ngFor="let type of commercialPremisesTypes; let i = index">
          <div class="city" *ngIf="i > 4">
            <label class="container-checkbox check-floor">{{type.title}}
              <input type="checkbox" [(ngModel)]="type.checked" (ngModelChange)="type.checked = $event"
                (change)="changedModel()">
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="appartment-action">
  <div class="btn" [ngClass]="onchangeModel ? 'btn-apply' : 'btn-cancel'" (click)="onchangeModel ? saveState() : null">
    Подтвердить</div>
  <div class="btn btn-cancel" (click)="cancel()">Отменить</div>
</div>
